var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalIconThreeGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.992,
    height: 16.964,
    viewBox: "0 0 17.992 16.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11766",
    "data-name": "Group 11766",
    transform: "translate(-2 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49533",
    "data-name": "Path 49533",
    d: "M9,14.311H5.213a.643.643,0,0,1,0-1.285H8.246a6.466,6.466,0,0,1-.424-1.214H5.213a.643.643,0,0,1,0-1.285H7.635c-.006-.109-.006-.212-.006-.321a6.831,6.831,0,0,1,.36-2.185H4.313A2.316,2.316,0,0,0,2,10.333V17A2.307,2.307,0,0,0,4.069,19.3v1.356a.973.973,0,0,0,.977.977.949.949,0,0,0,.6-.212L7.1,20.28a4.492,4.492,0,0,1,2.782-.97h4.447A2.315,2.315,0,0,0,16.638,17v-.334A6.816,6.816,0,0,1,9,14.311Zm.315,2.506H5.213a.643.643,0,1,1,0-1.285H9.319a.643.643,0,0,1,0,1.285Z",
    transform: "translate(0 -1.866)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49534",
    "data-name": "Path 49534",
    d: "M18.3,2.8a5.539,5.539,0,1,0,5.539,5.539A5.544,5.544,0,0,0,18.3,2.8Zm-.006,9.105a.643.643,0,0,1-.006-1.285h.006a.643.643,0,0,1,0,1.285Zm.649-2.969v.392a.643.643,0,0,1-1.285,0V8.416a.644.644,0,0,1,.643-.643.549.549,0,1,0-.553-.553.643.643,0,1,1-1.285,0,1.838,1.838,0,1,1,2.48,1.716Z",
    transform: "translate(-3.846)",
    fill: "gray"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIconThreeGrey);
export default __webpack_public_path__ + "static/media/legal-icon-three-grey.de1049fc0bfca567872ade9f98e6c63a.svg";
export { ForwardRef as ReactComponent };